export const tableHand = {
    en: {
        radial_menu: {
            flip: 'Flip (F)',
            put_in_hand: 'Take in hand (H)',
            put_on_table: 'Put on table (T)',
            pass_to_player: 'Pass to player',
            delete: 'Delete',
            lock: 'Lock (L)',
            unlock: 'Unlock (L)',
            zoom: 'Preview (Space)',
            shuffle: 'Shuffle (S)',
            deal_x_cards: 'Deal X cards to all',
            put_x_cards: 'Take X cards in hand'
        },
        hand: {
            empty_hand: 'Your hand is empty'
        }
    },
    ru: {
        radial_menu: {
            flip: 'Перевернуть (F)',
            put_in_hand: 'Взять со стола в руку (H)',
            put_on_table: 'Отправить на стол (T)',
            pass_to_player: 'Отправить другому игроку',
            delete: 'Удалить',
            lock: 'Заблокировать (L)',
            unlock: 'Разблокировать (L)',
            zoom: 'Увеличить (Пробел)',
            shuffle: 'Перемешать (S)',
            deal_x_cards: 'Раздать всем Х карт',
            put_x_cards: 'Взять Х карт в руку'
        },
        hand: {
            empty_hand: 'В руке нет карт'
        }
    }
};
